/* sp-pdp-sum.js – 17.10.2026 (Oliver): die schwarze Preis-Leiste der Probe entfällt (CSS: sp-pdp-sum.css),
   „Deine Bestellung“ zeigt stattdessen Gesamt netto groß und brutto klein.
   Werte kommen aus [data-spn-l-total] (brutto, von sp-pdp-neu.js) – keine eigene Preisrechnung.
   Läuft nur, wenn die Probe aktiv ist (.prb-on). Aufruf: snippets/sp-pdp-probe.liquid */
(function () {
  'use strict';
  var EN = /^\/en(\/|$)/.test(location.pathname) || /^en/i.test(document.documentElement.lang || '');
  var VAT = 1.19;
  function T(de, en) { return EN ? en : de; }
  function eur(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function centsOf(t) { var m = /(\d{1,3}(?:[.,\s]\d{3})*|\d+)[,.](\d{2})(?!\d)/.exec(String(t || '')); return m ? parseInt(m[1].replace(/[.,\s]/g, ''), 10) * 100 + parseInt(m[2], 10) : 0; }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function init(root) {
    var sum = root.querySelector('.spn-sum'), lTot = sum && sum.querySelector('[data-spn-l-total]'), dl = lTot && lTot.closest('.spn-lines');
    if (!dl || sum.classList.contains('prb-sum')) return;
    sum.classList.add('prb-sum');
    var box = document.createElement('div');
    box.className = 'prb-net';
    box.innerHTML = '<div class="prb-net__row"><span class="prb-net__l"></span><b class="prb-net__v"></b></div><p class="prb-net__unit"></p><p class="prb-net__gross"></p>';
    dl.parentNode.insertBefore(box, dl.nextSibling);
    var cta = sum.querySelector('.spn-cta');
    if (cta) { var pr = document.createElement('p'); pr.className = 'prb-net__proof'; pr.textContent = '✉ ' + T('Vor der Produktion bekommst du eine Druckfreigabe per E-Mail.', 'Before production you’ll receive a print approval by email.'); cta.parentNode.insertBefore(pr, cta.nextSibling); }
    var meta = sum.querySelector('[data-spn-summeta]'), dlab = sum.querySelector('[data-spn-l-disclabel]');
    function upd() {
      var gross = centsOf(lTot.textContent);
      var pieces = parseInt(((meta && meta.textContent) || '').replace(/[^\d\s].*$/, '').replace(/\s/g, ''), 10) || 0;
      var pm = /(\d+)\s*%/.exec((dlab && dlab.textContent) || ''), pct = pm ? parseInt(pm[1], 10) : 0;
      setText(box.querySelector('.prb-net__l'), T('Gesamt netto', 'Total net'));
      setText(box.querySelector('.prb-net__v'), eur(gross / VAT));
      setText(box.querySelector('.prb-net__unit'), pieces ? T('entspricht ', 'equals ') + eur(gross / VAT / pieces) + T(' je Stück netto', ' per piece net') + (pct ? T(' · inkl. ' + pct + ' % Staffelrabatt', ' · incl. ' + pct + ' % volume discount') : '') : '');
      setText(box.querySelector('.prb-net__gross'), T('brutto ', 'gross ') + eur(gross) + (pieces ? ' · ' + eur(gross / pieces) + T(' je Stück', ' per piece') : '') + T(' · inkl. 19 % MwSt.', ' · incl. 19 % VAT'));
    }
    var mo = new MutationObserver(upd);
    [lTot, meta, dlab].forEach(function (el) { if (el) mo.observe(el, { childList: true, subtree: true, characterData: true }); });
    upd();
  }

  var tries = 0;
  (function wait() {
    var roots = document.querySelectorAll('.prb-on');
    if (roots.length) { Array.prototype.forEach.call(roots, init); return; }
    if (++tries < 60) setTimeout(wait, 250);
  })();
})();
